import * as styles from "./ProfilerToolbar.css";

import { useCallback, useRef, useState } from "react";

import { Icon } from "@frontend/components/atoms/Icon";
import { Popover, PopoverContent } from "@frontend/components/atoms/Popover";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@frontend/components/atoms/Tooltip";

import { CollectionSwitch } from "../components/CollectionSwitch";
import { ProfilerFolded } from "./ProfilerFolded";
import { useCollapsed } from "./preferences";
import { useDraggablePosition } from "./useDraggablePosition";

export function ProfilerOffToolbar() {
  const [open, setOpen] = useState(false);

  const buttonRef = useRef<HTMLButtonElement>(null);

  const toggle = useCallback(() => setOpen((value) => !value), []);

  const { position, settling, onPointerDown, measure } = useDraggablePosition(
    buttonRef,
    styles.BUTTON_ESTIMATE,
    toggle,
  );
  const [collapsed, setCollapsed] = useCollapsed();

  return (
    <Popover open={open} onOpenChange={setOpen}>
      {collapsed ? (
        <ProfilerFolded
          ref={buttonRef}
          position={position}
          size={measure()}
          label="off"
          open={open}
          onClick={toggle}
          onExpand={() => {
            setOpen(false);
            setCollapsed(false);
          }}
        />
      ) : (
        <Tooltip>
          <TooltipTrigger
            render={
              <button
                ref={buttonRef}
                type="button"
                className={`${styles.button} ${styles.off}`}
                style={{ left: position.x, top: position.y }}
                data-settling={settling || undefined}
                onPointerDown={onPointerDown}
                onDoubleClick={() => {
                  setOpen(false);
                  setCollapsed(true);
                }}
                aria-label="Profiler"
                aria-expanded={open}
              />
            }
          >
            <span>profiler off</span>
          </TooltipTrigger>
          <TooltipContent side="top">
            This request was not profiled: click to turn collection on
          </TooltipContent>
        </Tooltip>
      )}
      <PopoverContent anchor={buttonRef} side="top" align="end">
        <div className={styles.panel}>
          <span className={styles.muted}>
            This request was not profiled: collection is on demand here, for
            failures, slow requests and the browsers that ask for it.
          </span>
          <CollectionSwitch />
          <div className={styles.links}>
            <a
              className={styles.link}
              href="/profiler/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Open the profiler
              <Icon name="ExternalLink" size="sm" />
            </a>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
}
